// Ambient looping video for banner cards (see snippets/card-image.liquid).
// The card image stays underneath as poster/fallback; the video only loads once the card is near the
// viewport, fades in when it is actually playing, and pauses off-screen. Skipped for reduced motion / data saver.
if (!customElements.get('card-video')) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = navigator.connection && navigator.connection.saveData;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      entry.target.visible = entry.isIntersecting;
      entry.target.toggle(entry.isIntersecting);
    });
  }, { rootMargin: '200px 0px' });

  // Some mobile browsers pause muted loops when the tab is backgrounded and don't resume them.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    document.querySelectorAll('card-video').forEach((el) => el.visible && el.toggle(true));
  });

  customElements.define('card-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || saveData || reduceMotion.matches) return;
      this.video.muted = true;
      this.video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
      observer.observe(this);
    }

    disconnectedCallback() {
      observer.unobserve(this);
    }

    toggle(visible) {
      const { video } = this;
      if (visible) {
        if (!video.src) {
          video.src = video.dataset.src;
          video.load();
        }
        video.play().catch(() => {});
      } else if (!video.paused) {
        video.pause();
      }
    }
  });
}
